module.exports = __webpack_public_path__ + "img/一星特级大师@3x.33a3ac27.png";